import Vue from 'vue'
import Vuex from 'vuex'
import menu from './modules/menu'
import message from './modules/message'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    menu,
    message
  }
}) 